import React from "react";
import { Grid, Paper, Typography, Box, Link, Divider } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import FaxIcon from "@mui/icons-material/Print";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

export default function ContactUs() {
  return (
    <Box sx={{ p: { xs: 2, md: 5 } }}>
      {" "}
      {/* ✅ Outer padding added here */}
      <Paper
        elevation={4}
        sx={{
          maxWidth: "1200px",
          margin: "auto",
          borderRadius: 3,
          overflow: "hidden",
        }}
      >
        <Grid container>
          {/* Map Section */}
          <Grid item xs={12} md={6} sx={{ height: { xs: 300, md: "500px" } }}>
            <iframe
              title="company-location"
              src="https://www.google.com/maps/embed/v1/place?key=AIzaSyASqXP9IihjRb_UZMYaCC4Zx9A_XzPkSos&q=Menara Cosway"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </Grid>

          {/* Contact Details Section */}
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              p: 4,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Typography variant="h4" fontWeight="bold" gutterBottom>
              BLoyalty Sdn Bhd
            </Typography>

            <Divider sx={{ mb: 2 }} />

            <InfoRow
              icon={<LocationOnIcon />}
              text="Level 16, Menara Cosway (Plaza Berjaya)  No. 12, Jalan Imbi 55100, Kuala Lumpur"
            />
            <InfoRow
              icon={<EmailIcon />}
              text={
                <Link href="mailto:saku@binfinite.com.my">
                  saku@binfinite.com.my
                </Link>
              }
            />
            <InfoRow
              icon={<AccessTimeIcon />}
              text="Monday - Friday: 9:00 AM - 6:00 PM"
            />
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
}

// Reusable row component
function InfoRow({ icon, text }) {
  return (
    <Box display="flex" alignItems="center" mb={1.5}>
      <Box sx={{ color: "primary.main", mr: 1 }}>{icon}</Box>
      <Typography>{text}</Typography>
    </Box>
  );
}
